<template>
	<section class="section--map">
		<div class="garage-search__map">
			<Map
				v-bind:center="mapCenter"
				v-bind:zoom="mapZoom"
				v-bind:options="{ mapTypeControl: true, streetViewControl: false, rotateControl: false, fullscreenControl: false }"
				ref="google_map"
				map-type-id="roadmap"
				class="garage-search__map"
			>
				<Marker
					v-for="garage in garageStore.garages"

					v-bind:clickable="true"
					v-bind:key="garage.id"
					v-bind:position="garage.position"
          v-bind:icon="mapMarkerIcon(garage)"

					v-on:click="garageMarkerClick(garage)"
				/>
			</Map>
		</div>
	</section>
</template>

<script setup lang="ts">

import { convertGarages, loadData } from '@/data/api';
import { useGarageStore } from '@/stores/garages';
import type { Garage, ParkingSharingCharging, Position } from '@/types.d';
import { Map, Marker } from '@fawmi/vue-google-maps';
import { CategoryType as Category } from '@/types.d';
import { inject, ref,  watch } from 'vue';
import { useConditionWatcher } from 'vue-condition-watcher';

const garageStore = useGarageStore();

const { conditions, data, loading, error, execute: fetchData } = useConditionWatcher({
	fetcher: ( {endpoint , ...params }: any ) => {
		return loadData(endpoint, params)
	},
	conditions: {
		'f[0]': 'type:' + Category.PARKING,
	},
	defaultParams: {
		endpoint: inject('endpoint')
	},
	immediate: false,
	afterFetch: (data) => {
		garageStore.setGarages(convertGarages(data));

		return data;
	}
});


const google_map = ref();
const mapSettings: { [key:string]: any } = inject('map_settings', {})
let mapCenter: Position|undefined = inject('garage_location');
if( ! mapCenter ) {
	mapCenter = mapSettings.center;
}
const mapZoom = ref(mapSettings.zoom);

const icons: ( ParkingSharingCharging & ContractedParkingChargingSharing ) | undefined = inject('icons')

const iconSizes = function(garage: Garage) {
	let defaultSize = {width: 55, height: 55};
	if( mapCenter?.lat == garage.lat && mapCenter?.lng == garage.lng ) {
		defaultSize.width = defaultSize.height = 80;
	}

	return defaultSize;
}

const mapMarkerIcon = function( garage: Garage ) {
  let iconUrl = '';

  if( ! icons ) {
    return 'https://mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-poi.png';
  }

  if( garage.contracted_project) {
    iconUrl = icons.parking_contracted;
  }else{
    iconUrl = icons.parking;
  }

  return {
    url: iconUrl,
    scaledSize: iconSizes(garage)
  }
}

const garageMarkerClick = function(garage: Garage) {
	let target = garage.url;
	if( garage.external_url?.length ) {
		target = garage.external_url;
	}
	window.location.href = target;
};

watch(google_map, (map_component) => {
	if (map_component) {
		map_component.$mapPromise.then( (map: google.maps.Map) => {
			fetchData();
		});
	}
});

</script>